import { request } from '@/utils/request'
const DeviceManageService = {
  state: {},

  mutations: {},

  actions: {
    // 获取所有的通用属性
    GetAllMerchants({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Assets/AssetsFirm/GetAllMerchants', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default DeviceManageService
